import { queryOptions } from '@tanstack/react-query';
import { maxRolesQueryOptions } from '#api/roles.queries.ts';
import type { Item } from '#components/patterns/forms/select/select-async-searchable/SelectAsyncSearchable.tsx';
import { NO_ROLE_OPTION } from './option-constants.ts';

/**
 * Fetches a list of every role in the account, 500 at a time, up to 5000 roles.
 */
export function makeAllRolesQueryOptions(filterRoles: (option: Item) => boolean = () => true) {
  return queryOptions({
    ...maxRolesQueryOptions,
    select: (data) => {
      return {
        items: [NO_ROLE_OPTION, ...data.data.map((role) => ({ value: role.id, label: role.name }))].filter((element) =>
          filterRoles(element)
        ),
      };
    },
  });
}
